export enum InvoiceStatus {
  Quotation = 1,
  Rejected = 2,
  Delivery = 3,
  Invoice = 4,
}

export enum InvoiceStatusDescription {
  Quotation = 'N°. Cotizacion',
  Delivery = 'N°. Entrega',
  Invoice = 'N°. Factura',
  Unknown = 'N/A',
}
